var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "settings-engineers-security-group" } }, [
    _vm.aclHelper.getSettingsUpdateAccess()
      ? _c(
          "div",
          { staticClass: "row controls" },
          [
            _c("AddGroup", { attrs: { allGroups: _vm.headers } }),
            _vm._v(" "),
            !_vm.allowEdit
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: { id: "settings-engineers-security-group-edit" },
                    on: {
                      click: function ($event) {
                        return _vm.enableEdit()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("action.edit")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.allowEdit
              ? _c(
                  "button",
                  {
                    directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                    staticClass: "btn btn--darkblue",
                    attrs: { id: "settings-engineers-security-group-cancel" },
                    on: {
                      click: function ($event) {
                        return _vm.discardChange()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("action.cancel")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.allowEdit
              ? _c(
                  "button",
                  {
                    directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                    staticClass: "btn btn--orange",
                    attrs: { id: "settings-engineers-security-group-save" },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("action.save")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { attrs: { id: "settings-engineers-security-group-data" } }, [
      _c("table", { staticClass: "security-group-table setting-table" }, [
        _c(
          "thead",
          [
            _c("th", { staticClass: "resource-header" }, [
              _vm._v("\n          " + _vm._s(_vm.defaultHeader) + "\n        "),
            ]),
            _vm._v(" "),
            _vm._l(_vm.headers, function (header, index) {
              return [
                Math.ceil((index + 1) / _vm.headerPageSize) ===
                _vm.headerPageNum
                  ? _c("th", { key: index }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            id:
                              "settings-engineers-security-group-role-" + index,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.navToDetail(header.id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(header.name) +
                              "\n              "
                          ),
                          _c("i", {
                            staticClass: "fa fa-external-link",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            }),
            _vm._v(" "),
            _c("th", { staticStyle: { "min-width": "70px", padding: "0" } }, [
              _c(
                "button",
                {
                  staticClass: "btn icon right",
                  attrs: {
                    id: "settings-engineers-security-group-right-arrow",
                    type: "button",
                    disabled:
                      Math.ceil(_vm.headers.length / _vm.headerPageSize) <=
                      _vm.headerPageNum,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changePage(true)
                    },
                  },
                },
                [_vm._v("\n            ▶\n          ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn icon right",
                  attrs: {
                    id: "settings-engineers-security-group-left-arrow",
                    type: "button",
                    disabled: _vm.headerPageNum <= 1,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changePage(false)
                    },
                  },
                },
                [_vm._v("\n            ◀\n          ")]
              ),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.sortedPermissions, function (actions, resource, index) {
              return [
                _vm.isEnabledFeature(resource)
                  ? _c(
                      "tr",
                      { key: resource + "_name_" + index },
                      [
                        _c("td", [
                          !_vm.collapse[resource]
                            ? _c(
                                "button",
                                {
                                  staticClass: "collapse-icon",
                                  attrs: {
                                    id:
                                      "settings-engineers-security-group-collapse-" +
                                      resource,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.collapseItem(resource, true)
                                    },
                                  },
                                },
                                [_vm._v("\n                −\n              ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.collapse[resource]
                            ? _c(
                                "button",
                                {
                                  staticClass: "collapse-icon",
                                  attrs: {
                                    id:
                                      "settings-engineers-security-group-expanse-" +
                                      resource,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.collapseItem(resource, false)
                                    },
                                  },
                                },
                                [_vm._v("\n                +\n              ")]
                              )
                            : _vm._e(),
                          _vm._v(
                            "\n\n              " +
                              _vm._s(_vm.getName(resource)) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.headers, function (header, key) {
                          return [
                            Math.ceil((key + 1) / _vm.headerPageSize) ===
                            _vm.headerPageNum
                              ? _c("td", {
                                  key: header.id + "_resource_" + key,
                                })
                              : _vm._e(),
                          ]
                        }),
                        _vm._v(" "),
                        _vm.headers.length >= _vm.headerPageSize
                          ? _c("td")
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEnabledFeature(resource) && !_vm.collapse[resource]
                  ? _vm._l(actions.permissions, function (perms, action) {
                      return _c(
                        "tr",
                        { key: resource + "_perm_" + action },
                        [
                          _c("td", { staticClass: "action" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.renderedAction(resource, action)) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.headers, function (header, index2) {
                            return [
                              Math.ceil((index2 + 1) / _vm.headerPageSize) ===
                              _vm.headerPageNum
                                ? _c(
                                    "td",
                                    {
                                      key:
                                        index2 +
                                        "_" +
                                        header.id +
                                        "_" +
                                        action +
                                        "_" +
                                        perms[header.id],
                                    },
                                    [
                                      _vm.allowEdit || perms[header.id]
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: perms[header.id],
                                                expression: "perms[header.id]",
                                              },
                                              {
                                                name: "hkldinput",
                                                rawName: "v-hkldinput",
                                              },
                                            ],
                                            key:
                                              header.id +
                                              "_" +
                                              action +
                                              "_" +
                                              perms[header.id],
                                            attrs: {
                                              type: "checkbox",
                                              disabled: _vm.disableCheckbox(
                                                index2,
                                                header.id,
                                                resource,
                                                action
                                              ),
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                perms[header.id]
                                              )
                                                ? _vm._i(
                                                    perms[header.id],
                                                    null
                                                  ) > -1
                                                : perms[header.id],
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a = perms[header.id],
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          perms,
                                                          header.id,
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          perms,
                                                          header.id,
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      perms,
                                                      header.id,
                                                      $$c
                                                    )
                                                  }
                                                },
                                                function ($event) {
                                                  return _vm.updateGrantedAccess(
                                                    header.id,
                                                    resource,
                                                    action
                                                  )
                                                },
                                              ],
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          }),
                          _vm._v(" "),
                          _c("td"),
                        ],
                        2
                      )
                    })
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }